<template>
    <div class="banner banner--theme banner--home">

        <div class="banner-primary">
            <div class="container">
                <div class="col-content col-content--primary">
                    <div class="banner-content">
                        <h1 class="medium small" v-html="data.title"></h1>
                        <div class="wysiwyg-content" v-html="data.content"></div>

                        <a v-if="data.ctaButton==='page-link'"
                            :href="data.ctaLink.link"
                            :taget="data.ctaLink.openInNewWindow ? '_blank' : null"
                            class="button button--solid-black" 
                        >{{ data.ctaLink.label }}</a>
                    </div>
                </div>
                <div class="col-slider position-relative">
                    <slider-news :data="data" />
                </div>
            </div>
        </div>

        <div class="banner-secondary">
            <div class="container">
                <div class="col-content col-content--secondary">
                    <div class="inner">
                        <div class="item"
                            v-for="(action, index) in data.actions"
                            :key="index"
                        >
                            <a :href="action.link" :title="action.title" :aria-label="action.title">
                                <h6 class="title medium">{{action.title}}</h6>
                                <p v-html="action.content"></p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import { defineAsyncComponent } from "vue"
const SliderNews = defineAsyncComponent(() => import(/* webpackChunkName:'SliderNews' */ '../../components/Sliders/SliderNews.vue'))

export default {
    name: "banner-image",
    components: {
        SliderNews
    },
    props: {
        data: {
            type: Object
        }
    },
    data () {
        return {
            isModalVisible: false,
        }
    },
    methods: {
        showPersonaModal() {
            this.$refs.personaFull.showPersonaModal();
        },
    }
};
</script>

<style lang="scss" scoped>
@import "../../../scss/abstracts/mixins";
@import "../../../scss/abstracts/variables";

.position-relative {
    position: relative;
}
.banner--home {
    position: relative;
    min-height: auto;

    @media #{$lg} {
        min-height: 100vh;
    }

    .container {
        display: block;

        @media #{$lg} {
            display: flex;
        }

        .col-content {
            width: 100%;
            display: block;

            @media #{$lg} {
                width: 60%;
                display: flex;
                align-items: center;
            }

            .banner-content {
                max-width: 100%;
                margin-top: 0;

                @media (min-width:992px) {
                    padding: 1rem 0;
                }
            }
        }

        .col-slider {
            width: 100vw;
            background-color: #e8e8e8;
            position: relative;
            right: 0;
            bottom: 0;
            min-height: 320px;
            max-height: 320px;
            overflow: hidden;

            margin: 0 -#{$outer-container-margin};
            
            @media #{$sm} {
                margin: 0 -#{$outer-container-margin};
                margin: 0 (($grid-col-base + $grid-gutter-base) * (-1));
            }

            @media #{$lg} {
                width: calc(40% - 1rem);
                position: absolute;
                top: 130px;
                min-height: calc(100vh - 130px);
                max-height: calc(100vh - 130px);
                margin: auto;
                margin-top: 0;
            }
        }
    }

    .banner-primary {
        background-color: $brand-blue;

        .container {
            .col-content {
                height: auto;
                padding: 120px 0 60px 0;

                @media #{$lg} {
                    height: calc(100vh - 160px);
                    padding: 0;
                }
            }
        }
    }

    &.calculated {
        transition: all 200ms;
        
        .banner-primary {
            .container {
                .col-content {
                    @media #{$lg} {
                        padding-top: var(--nav-height, 130px);
                        height: calc(100vh - var(--secondary-height, 160px));
                    }
                }
            }
        }

        @media (min-width:992px) {
            &.narrow-height {
                .banner-primary {
                    .container {
                        .col-content {
                            height: 100vh;
                        }
                    }
                }
            }
        }
    }

    .banner-secondary {
        background-color: $brand-white;

        .container {
            padding-top: 30px;
            padding-bottom: 30px;
            overflow-x: scroll;

            min-height: 160px;
            display: flex;
            align-items: center;

            @media only screen and (max-width: 991px) {
                padding-top: 0.5rem;
                padding-bottom: 0.5rem;
                padding-left: ( $outer-container-margin - 1rem );
                padding-right: ( $outer-container-margin - 1rem );
            }

            @media #{$lg} {
                overflow-x: hidden;
            }

            .col-content {
                min-height: auto;
                min-width: 0;
                display: flex;
                align-items: unset;
                padding-top: 1rem;
                padding-bottom: 1rem;

                @media #{$lg} {
                    min-width: auto;
                }

                .inner {
                    display: flex;

                    @media #{$lg} {
                        margin-left: -30px;
                        margin-right: -30px;
                    }
                }

                .item {
                    padding: 0px;
                    width: 45vw;
                    flex-shrink: 0;
                    display: inline-block;
                    position:relative;
                    align-items: center;

                    &::after{
                        display: block;
                        content : '';
                        background-color: black;
                        width:1px;
                        position:absolute;
                        right: 0;
                        top: 0;
                        bottom: 0;
                        margin: auto;

                    }


                    @media #{$sm} {
                        display: inline-block;
                    }
                
                    @media #{$md} {
                        display: inline-block;
                    }

                    @media #{$lg} {
                        padding: 5px 30px;
                        display: flex;
                        align-items: flex-start;
                        width: 33.33333%;
                    }

                    &:first-of-type {
                        padding: 0;

                        @media #{$lg} {
                            padding: 5px 30px;
                        }
                    }

                    &:last-of-type {
                        border-right: none;

                        &::after{
                            display: none;


                        }
                    }

                    a {
                        padding: 0 1rem;
                        display: block;
                        height: auto;

                        @media #{$lg} {
                            padding: 0;
                        }
                    }

                    .title {
                        margin-top: 0;
                        margin-bottom: 10px;
                        @include font-size(16);
                    }
                    
                    p {
                        margin-top: 0;
                        @include font-size(12);
                        line-height: 1.5;
                    }

                    :first-child {
                        margin-top: 0.25rem;
                    }

                    :last-child {
                        margin-bottom: 0.25rem;
                    }
                }
            }
        }
    }

    &.calculated.narrow-height {
        .col-content--secondary {
            @media (min-width:992px) {
                width: 100%;
                display: block;
            }
        }
    }
}

h1 {
    margin-top: 0;

    &.medium {
        /** COL-321 */
        @media (min-width:992px) and (max-width:1365px) {
            font-size: 2.875rem; 
        }
    }
}

.wysiwyg-content {
    /** COL-321 */
    @media (min-width:992px) and (max-width:1365px) {
        font-size: 14px;
        margin-bottom: .5rem;
    }
}
</style>


<style lang="scss">
.banner--home {
    .wysiwyg-content {
        > :first-child {
            margin-top: 0;
        }

        > :last-child {
            margin-bottom: 0;
        }

        p {
            /** COL-321 */
            @media (min-width:992px) and (max-width:1365px) {

                line-height: 1.5;
                margin: 0 0 1rem 0;

                &:last-child {
                    margin: 0;
                }
                
            }

            span.button {
                padding: 0;

                a {
                    display: block;
                    padding: 10px 40px;
                    text-decoration: none;
                    opacity: 1 !important;
                }
            }
        }
    }
}
</style>